// components/Dashboard/TopSellingProductsTable.tsx
import { Package } from "lucide-react";
import type { TopProduct } from "../../types/sales";

interface Props {
  products: TopProduct[];
  onViewAll?: () => void;
}

export const TopSellingProductsTable: React.FC<Props> = ({ products, onViewAll }) => {
  return (
    <div className="rounded-xl bg-white/80 border p-4 shadow-sm overflow-x-auto">
      {/* Header */}
      <div className="flex justify-between items-center mb-3">
        <h3 className="text-lg font-bold text-primary">
          Top Selling Products
        </h3>

        {onViewAll && (
          <button
            onClick={onViewAll}
            className="text-sm text-primary hover:underline"
          >
            View product sales history
          </button>
        )}
      </div>

      {/* Table */}
      <table className="w-full text-sm min-w-[600px]">
        <thead className="text-blue-900 border-b">
          <tr>
            <th className="text-left py-2">Product</th>
            <th className="text-left py-2">Price</th>
            <th className="text-left py-2">Sold</th>
            <th className="text-left py-2">Revenue</th>
            <th className="text-left py-2">Remaining (Across Stores)</th>
          </tr>
        </thead>

        <tbody>
          {products.length === 0 && (
            <tr>
              <td colSpan={5} className="py-6 text-center text-gray-500">
                No product sales for this period
              </td>
            </tr>
          )}

          {products.map((p) => (
            <tr
              key={p.id}
              className="border-b last:border-none hover:bg-gray-50 transition"
            >
              <td className="py-2 font-medium">
                    <div className="flex items-center gap-2">
                      {p.image_url ? (
                        <img src={p.image_url} alt={p.name} className="w-8 h-8 rounded object-cover flex-shrink-0" />
                      ) : (
                        <Package size={20} className="text-gray-400 flex-shrink-0" />
                      )}
                      {p.name}
                    </div>
                  </td>
              <td className="py-2">GHS {p.price.toLocaleString()}</td>
              <td className="py-2">{p.sold}</td>
              <td className="py-2 font-medium">
                GHS {p.revenue.toLocaleString()}
              </td>
              <td className="py-2">{p.remaining}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default TopSellingProductsTable;
